import { __awaiter } from '../../../../external_node_modules/tslib/tslib.es6.js';
import { getStorefrontByPlatform } from '../../../../api/storefront.js';
import { PLATFORMS } from '../../../../constants/platforms.js';
import settings from '../../../../settings.js';

function getMockedItems(customStorefrontName) {
    return __awaiter(this, void 0, void 0, function* () {
        const storefront = yield getStorefrontByPlatform(PLATFORMS.WIN_STORE, customStorefrontName);
        const products = Object.values(storefront.products || {});
        return products.map((product) => ({
            description: product.description,
            productId: product.externalProductId,
            price: product.price,
            title: product.title,
            currencyCode: product.currency,
            language: settings.language,
            inAppOfferToken: product.externalProductId,
            inProgress: false,
            salePrice: product.originalPrice,
            saleEndDate: '2021-10-20',
        }));
    });
}
function getMockedWinStoreUserCountry() {
    return __awaiter(this, void 0, void 0, function* () {
        return settings.country || 'DE';
    });
}

export { getMockedItems, getMockedWinStoreUserCountry };
//# sourceMappingURL=mock.js.map
